import { useEffect, useState } from "react";
import { api } from "../api/client";

export type Connection = {
  bff: "ok" | "error" | "unknown";
  upstream: "ok" | "error" | "unknown";
  upstreamUrl?: string;
};

// Poll periódico (cada 15s) para o /api/health e /api/upstream/health.
// Atualiza a sidebar com o estado das conexões.
export function useConnection(intervalMs = 15_000): Connection {
  const [state, setState] = useState<Connection>({ bff: "unknown", upstream: "unknown" });

  useEffect(() => {
    let cancelled = false;
    async function check() {
      const own = await api.health();
      if (cancelled) return;
      if (!own.ok) {
        setState({ bff: "error", upstream: "unknown" });
        return;
      }
      const upstreamUrl = (own.data && (own.data as { upstream?: string }).upstream) ?? undefined;
      const up = await api.upstreamHealth();
      if (cancelled) return;
      setState({
        bff: "ok",
        upstream: up.ok ? "ok" : "error",
        upstreamUrl,
      });
    }
    void check();
    const id = setInterval(check, intervalMs);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [intervalMs]);

  return state;
}
